module.exports = __webpack_public_path__ + "static/media/Cybersecurity.418dfbf2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Tracks/img/newlogos/Cybersecurity.svg
// module id = 243
// module chunks = 0